import {persistedUTMParamsKeys} from 'modules/search/constants'
import {pick} from 'ramda'

import {decorateUrlWithSubBrand} from '@vio/core/src/_web/brand/utils'
import urls from '@vio/core/src/utils/url'

import type {Brand} from '@vio/core/src/brand/types'

/**
 * Factory function that return utm params from URL
 * @returns utm params
 */
export const getUtmParams = (queryString: string) => {
  const searchParams = new URLSearchParams(queryString)
  return new URLSearchParams(
    pick(persistedUTMParamsKeys, Object.fromEntries(searchParams))
  )
}

/**
 * Factory function that return URl with persisted utm params
 * @param hasOrigin  - return url with origin
 * @deprecated - use `getHomeLinkWithUTMParams` which is pure instead
 * @returns string
 */
export const getHomeUrlWithUTMParams = (hasOrigin = true): string => {
  if (typeof window === 'undefined') {
    return urls.root
  }

  const {origin} = new URL(window.location.href)

  const rootURL = urls.root
  const utmParams = getUtmParams(window.location.search)
  const stringPrams = utmParams.toString()

  const homeUrl = `${hasOrigin ? origin : ''}${rootURL}${
    stringPrams ? ['?', stringPrams].join('') : ''
  }`
  // Decorate URL with subBrand if present in current URL
  return decorateUrlWithSubBrand(homeUrl)
}

/**
 * Get the homepage URl with persisted utm params (pure version)
 * @param currentQueryString - the current (or landing) query string
 * @param brand - active brand
 * @param withOrigin - return url with origin
 * @returns string
 */
export const getHomeLinkWithUTMParams = (
  currentQueryString: string,
  brand: Brand,
  withOrigin = true
): string => {
  const origin = withOrigin ? brand.siteAddresses.address : ''
  const rootPath = urls.root

  const utmParams = getUtmParams(currentQueryString)
  const stringParams = utmParams.toString()

  const homeUrl = `${origin}${rootPath}${stringParams ? `?${stringParams}` : ''}`
  // Decorate URL with subBrand if present in current URL
  return decorateUrlWithSubBrand(homeUrl)
}
